import { featureKeyEnum, useGetMyFeatureAccess } from "~/gen/api"

export type EcoModulationsFeatureAccessState = {
  readonly hasAccess: boolean
  readonly isPending: boolean
}

export const useEcoModulationsFeatureAccessState =
  (): EcoModulationsFeatureAccessState => {
    const { data: myFeatureAccessData, isPending } = useGetMyFeatureAccess(
      featureKeyEnum["eco-modulations"]
    )

    return {
      hasAccess: myFeatureAccessData?.data?.hasAccess ?? false,
      isPending,
    }
  }

export const useHasEcoModulationsFeatureAccess = (): boolean => {
  return useEcoModulationsFeatureAccessState().hasAccess
}
